var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdeasBackground = function SvgIdeasBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 614,
    height: 1295,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M299.374 298.863c-283.48 143.554-119.643 434.066-2.29 561.378 353.087 296.729 461.732-65.53 309.476-303.219-152.256-237.69 375.446-130.298 349.485-480.888-30.103-406.523-302.323 43.287-656.671 222.729Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M310.071 309.501C21.754 443.074 175.352 739.127 288.19 870.456c342.517 308.874 463.738-49.375 319.87-292.233-143.868-242.859 379.764-117.116 366.055-468.398-15.898-407.326-303.649 32.71-664.044 199.676Z",
    opacity: 0.959
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M320.389 320.506c-292.802 123.429-149.63 424.662-41.444 559.85C610.473 1201 744.123 847.195 608.818 599.464 473.514 351.732 992.439 495.673 990.997 144.126c-1.672-407.632-304.605 22.093-670.608 176.38Z",
    opacity: 0.917
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M330.317 331.864C33.385 445 165.957 751.045 269.36 889.926c320.136 332.014 466.052-16.906 339.475-269.208-126.576-252.303 387.009-90.34 397.835-441.722 12.56-407.443-305.189 11.448-676.353 152.868Z",
    opacity: 0.876
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M339.842 343.562c-300.698 102.704-178.888 413.19-80.396 555.595C567.8 1242.14 725.805 898.526 608.11 641.96s389.926-76.778 413.01-427.569c26.77-406.756-305.404.791-681.278 129.171Z",
    opacity: 0.835
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M348.954 355.584c-304.1 92.148-193.2 406.696-99.737 552.451 296.196 353.535 466.096 15.646 357.428-244.872-108.669-260.517 392.368-63.123 427.685-412.894 40.94-405.574-305.251-9.868-685.376 105.315Z",
    opacity: 0.794
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M357.64 367.918C50.51 449.396 150.365 767.623 238.684 916.552 522.361 1280.21 703.95 948.454 604.44 684.303s394.332-49.391 441.83-397.717c55.08-403.898-304.716-20.516-688.63 81.332Z",
    opacity: 0.752
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M365.891 380.547C56.104 451.257 144.792 772.775 227.86 924.695c270.812 373.335 463.869 48.121 373.638-219.343s395.816-35.599 455.442-382.055c69.14-401.73-303.815-31.137-691.049 57.25Z",
    opacity: 0.711
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M373.696 393.457C61.63 453.312 139.043 777.729 216.758 932.456c257.619 382.564 461.908 64.28 381.066-206.169s396.817-21.764 468.496-365.928c83.12-399.072-302.541-41.721-692.624 33.098Z",
    opacity: 0.67
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M381.045 406.631C67.08 455.559 133.125 782.48 205.392 939.825c244.111 391.325 459.383 80.365 388.03-192.745-71.354-273.106 397.334-7.902 480.978-349.355 97-395.928-300.898-52.254-693.355 8.906Z",
    opacity: 0.629
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M387.931 420.054C72.45 457.994 127.044 787.021 193.777 946.792c230.304 399.598 456.298 96.348 394.519-179.085-61.779-275.43 397.368 5.97 492.884-332.356 110.75-392.302-298.897-62.724-693.249-15.297Z",
    opacity: 0.588
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M394.342 433.708C77.729 460.616 120.808 791.348 181.923 953.35c216.219 407.4 452.659 112.21 400.53-165.208S979.37 807.977 1086.63 473.19c124.38-388.198-296.521-73.116-692.288-39.482Z",
    opacity: 0.546
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M400.275 447.578C82.915 463.42 114.425 795.454 169.85 959.49c201.869 414.69 448.466 127.94 406.051-151.129s395.983 33.675 514.869-297.164c137.84-383.621-293.796-83.421-690.495-63.619Z",
    opacity: 0.505
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M405.72 461.647c-317.719 4.756-297.816 337.687-248.149 503.559C344.844 1386.69 601.299 1108.72 568.648 828.34c-32.65-280.379 394.568 47.473 524.922-279.015 151.15-378.577-290.701-93.623-687.85-87.678Z",
    opacity: 0.464
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M410.669 475.897c-317.69-6.335-309.419 327.088-265.572 494.592 172.45 427.761 438.449 158.911 415.604-122.437-22.846-281.347 392.67 61.215 534.339-260.525 164.27-373.071-287.256-103.711-684.371-111.63Z",
    opacity: 0.422
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M415.121 490.311C97.844 472.893 94.474 806.402 132.449 975.333c157.416 433.527 432.636 174.117 419.623-107.857-13.012-281.973 390.295 74.882 543.108-241.719 177.19-367.11-283.463-113.673-680.059-135.446Z",
    opacity: 0.381
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M419.064 504.872C102.588 476.391 87.581 809.579 119.637 979.733c142.19 438.757 426.296 189.107 423.132-93.147s387.444 88.458 551.211-222.617c189.9-360.703-279.322-123.496-674.916-159.097Z",
    opacity: 0.34
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M422.497 519.561C107.208 480.053 80.582 812.515 106.681 983.684c126.791 443.446 419.436 203.866 426.125-78.323 6.688-282.194 384.12 101.929 558.644-203.245 202.37-353.856-274.842-133.17-668.953-182.555Z",
    opacity: 0.299
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M425.416 534.362C111.698 483.874 73.486 815.204 93.594 987.179c111.238 447.601 412.066 218.381 428.599-63.403 16.533-281.789 380.33 115.264 565.397-183.624 214.6-346.578-270.026-142.681-662.174-205.79Z",
    opacity: 0.258
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M427.818 549.255C116.053 487.85 66.301 817.644 80.395 990.216c95.549 451.214 404.194 232.634 430.551-48.407s376.075 128.471 571.464-163.78c226.56-338.877-264.886-152.017-654.592-228.774Z",
    opacity: 0.216
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M429.696 564.223c-309.432-72.248-370.664 255.608-362.6 428.568 79.743 454.269 395.828 246.599 431.977-33.352C535.222 679.49 870.435 1100.96 1075.9 815.702c238.25-330.764-259.414-161.169-646.204-251.479Z",
    opacity: 0.175
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M431.052 579.247C124.33 496.244 51.693 821.764 53.715 994.9c63.842 456.78 386.982 260.26 432.879-18.256 45.897-278.517 366.197 154.396 581.496-123.518 249.64-322.248-253.636-170.125-637.038-273.879Z",
    opacity: 0.134
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M431.883 594.31C128.244 500.653 44.291 823.44 40.27 996.54c47.861 458.73 377.663 273.61 433.252-3.137 55.589-276.746 360.586 167.077 585.448-103.149 260.74-313.339-247.539-178.873-627.087-295.944Z",
    opacity: 0.092
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M432.187 609.392C132.002 505.195 36.836 824.856 26.775 997.71c31.823 460.12 367.884 286.62 433.098 11.99 65.214-274.642 354.535 179.56 588.697-82.659 271.51-304.048-241.152-187.402-616.383-317.649Z",
    opacity: 0.051
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M431.965 624.476C135.599 509.866 29.335 826.011 13.248 998.409 28.994 1459.36 370.905 1297.7 445.663 1025.5c74.759-272.192 348.053 191.83 591.217-62.057 281.97-294.388-234.458-195.705-604.915-338.967Z",
    opacity: 0.01
  })));
};
export default SvgIdeasBackground;